module.exports = __webpack_public_path__ + "img/banner2.9a8101c6.jpg";